import { useApiStore } from '@/stores/apiStore';
import { OrgSpecApi } from '@/../generated-client/apis/OrgSpecApi';
import {
  OrgSpecAdminCreate,
  OrgSpecAdminUpdate,
  OrgSpecOnAzure,
} from '../../generated-client/models';

let orgSpecApi: OrgSpecApi | null = null;
let lastConfig: unknown = null;

function getOrgSpecApi(): OrgSpecApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (orgSpecApi === null || lastConfig !== apiConfig) {
    orgSpecApi = new OrgSpecApi(apiConfig);
    lastConfig = apiConfig;
  }

  return orgSpecApi;
}

export const addOrganizationConfiguration = async (
  configuration: OrgSpecAdminCreate,
) => {
  const api = getOrgSpecApi();

  return await api.apiOrgSpecAddPost({ orgSpecAdminCreate: configuration });
};

export const deleteOrganizationConfiguration = async (
  configuration: OrgSpecOnAzure,
) => {
  const api = getOrgSpecApi();

  return await api.apiOrgSpecDeleteDelete({
    orgSpecAdminDelete: {
      org_code: configuration.org_code,
      org_spec_azure_id: configuration.id,
    },
  });
};

export const updateOrganizationConfiguration = async (
  configuration: OrgSpecAdminUpdate,
) => {
  const api = getOrgSpecApi();

  return await api.apiOrgSpecUpdatePut({
    orgSpecAdminUpdate: configuration,
  });
};

export const getAllOrganizationConfigurations = async (orgCode: string) => {
  const api = getOrgSpecApi();

  return await api.apiOrgSpecGetAllByOrgCodeGet({
    orgCode,
  });
};

export const getConfigurationByOrgCodeAndId = async (
  orgCode: string,
  specId: string,
) => {
  const api = getOrgSpecApi();

  return await api.apiOrgSpecGetByOrgCodeAndIdGet({
    orgCode,
    orgSpecAzureId: specId,
  });
};
